import { getLanguageOrDefault } from 'utils/i18n/language';

import { getNavigatorLanguage } from './get-navigator-language';

export function inferLanguageFromNavigator() {
  const navigatorLanguage = getNavigatorLanguage();
  const languageCode = navigatorLanguage.split('-')[0];
  return getLanguageOrDefault(languageCode);
}
